/**
 * Convert Int64 to bigint
 *
 * @param {import('./Int64Type.js').BrandedInt64} value - Int64 value
 * @returns {bigint} BigInt value
 */
export function toBigInt(value) {
	return value;
}
